import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\tNew comment\r\n\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { id: "current" };
const _hoisted_6 = { id: "maximum" };
const _hoisted_7 = { class: "float-start mt-2" };
const _hoisted_8 = { class: "d-flex" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_11 = { class: "checkbox-aligned-buttons" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("h2", { class: "mt-2" }, "History", -1 /* HOISTED */);
const _hoisted_14 = { class: "alarm-comments" };
const _hoisted_15 = { class: "mt-2" };
const _hoisted_16 = { class: "fw-bold me-2" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = { class: "border p-2" };
const _hoisted_19 = { style: { "white-space": "pre-line" } };
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { key: 1 };
const _hoisted_23 = { class: "clearfix" };
const _hoisted_24 = { class: "float-end" };
const _hoisted_25 = { id: "current" };
const _hoisted_26 = { id: "maximum" };
const _hoisted_27 = { class: "float-start mt-2" };
const _hoisted_28 = { class: "d-flex" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_31 = { class: "checkbox-aligned-buttons" };
const _hoisted_32 = { class: "clearfix d-flex justify-content-center mt-2" };
const _hoisted_33 = { class: "float-end float-start-sm" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_container = _resolveComponent("b-container");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.showModal) = $event)),
        "header-bg-variant": "normal",
        size: "lg",
        onHidden: _ctx.onHidden
    }, {
        title: _withCtx(() => [
            _createTextVNode("\r\n\t\t\tAlarm Comments\r\n\t\t")
        ]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_b_button, {
                    type: "button",
                    variant: "primary",
                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showModal = false))
                }, {
                    default: _withCtx(() => [
                        _hoisted_34,
                        _createTextVNode(" Close\r\n\t\t\t\t")
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        default: _withCtx(() => [
            _createTextVNode(),
            _createVNode(_component_b_container, {
                class: "alarm-comments-container",
                clearfix: ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _hoisted_3,
                            _createTextVNode(),
                            _createVNode(_component_b_form_textarea, _mergeProps(_ctx.commentVal, {
                                name: "notes",
                                modelValue: _ctx.log.notes,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.log.notes) = $event)),
                                rows: "5",
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.comment && _ctx.attemptedSave },
                                maxlength: _ctx.maxCommentLength
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class", "maxlength"]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getCommentLength(_ctx.log.notes)), 1 /* TEXT */),
                                _createTextVNode(),
                                _createElementVNode("span", _hoisted_6, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_b_button, {
                                        type: "button",
                                        variant: "primary",
                                        onClick: _ctx.save,
                                        disabled: (_ctx.errors && _ctx.errors.comment) || _ctx.working
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_9,
                                            _createTextVNode(" Save\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                                    _createTextVNode(),
                                    _createVNode(_component_b_button, {
                                        class: "ms-2",
                                        type: "button",
                                        variant: "secondary",
                                        onClick: _ctx.cancel,
                                        disabled: (_ctx.errors && _ctx.errors.comment) || _ctx.working
                                    }, {
                                        default: _withCtx(() => [
                                            _hoisted_10,
                                            _createTextVNode(" Cancel\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_component_b_form_checkbox, {
                                            class: "ms-2",
                                            style: { "padding-top": "8px" },
                                            modelValue: _ctx.log.notifySiteContactGroup,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.log.notifySiteContactGroup) = $event)),
                                            size: "lg"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNotify\r\n\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue"])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs.records, (log) => {
                                var _a;
                                return (_openBlock(), _createElementBlock("div", null, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(log.authorName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedDate(log.whenEntered)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        (!_ctx.isEditingLog(log))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createElementVNode("div", _hoisted_18, [
                                                    _createElementVNode("p", _hoisted_19, _toDisplayString(log.notes), 1 /* TEXT */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("a", {
                                                    class: "pointer blue me-2",
                                                    onClick: ($event) => (_ctx.edit(log))
                                                }, "Edit", 8 /* PROPS */, _hoisted_20),
                                                _createTextVNode(),
                                                _createElementVNode("a", {
                                                    class: "pointer blue",
                                                    onClick: ($event) => (_ctx.remove(log))
                                                }, "Remove", 8 /* PROPS */, _hoisted_21)
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                _createVNode(_component_b_form_textarea, {
                                                    name: "notes",
                                                    modelValue: _ctx.editingLog.notes,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.editingLog.notes) = $event)),
                                                    rows: "5",
                                                    maxlength: _ctx.maxCommentLength
                                                }, null, 8 /* PROPS */, ["modelValue", "maxlength"]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getCommentLength(_ctx.editingLog.notes)), 1 /* TEXT */),
                                                        _createTextVNode(),
                                                        _createElementVNode("span", _hoisted_26, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_27, [
                                                        _createElementVNode("div", _hoisted_28, [
                                                            _createVNode(_component_b_button, {
                                                                type: "button",
                                                                variant: "primary",
                                                                onClick: _ctx.update,
                                                                disabled: ((_a = _ctx.editingLog) === null || _a === void 0 ? void 0 : _a.notes) == ''
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_29,
                                                                    _createTextVNode(" Save\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick", "disabled"]),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_button, {
                                                                class: "ms-2",
                                                                type: "button",
                                                                variant: "secondary",
                                                                onClick: _ctx.cancelEditing
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_30,
                                                                    _createTextVNode(" Cancel\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            _createElementVNode("div", _hoisted_31, [
                                                                _createVNode(_component_b_form_checkbox, {
                                                                    class: "ms-2",
                                                                    style: { "padding-top": "8px" },
                                                                    modelValue: log.notifySiteContactGroup,
                                                                    "onUpdate:modelValue": ($event) => ((log.notifySiteContactGroup) = $event),
                                                                    size: "lg"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNotify\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"])
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ]))
                                    ])
                                ]));
                            }), 256 /* UNKEYED_FRAGMENT */)),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_b_button, {
                                    type: "button",
                                    variant: "secondary",
                                    onClick: _ctx.loadMore,
                                    disabled: !_ctx.hasMoreLogs()
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\tLoad more...\r\n\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick", "disabled"])
                            ])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }),
            _createTextVNode(),
            _createTextVNode(),
            _createVNode(_component_StatusOverlayComponent, {
                visible: _ctx.working,
                message: "Wait..."
            }, null, 8 /* PROPS */, ["visible"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onHidden"]));
}
